import { useState } from "react";
import Pill from "./Pill";
import MinusCircle from "../../assets/icons/MinusCircle";
import PillInput from "./PillInput";
import PlusIcon from "../../assets/icons/PlusIcon";

/**
 * A list of modifiable pills
 *
 * @param children    The contents of the each pill
 * @param modifiable  If true then allow user to add/remove items
 */
const PillList = ({
  items,
  className,
  pillClassName,
  iconClassName,
  modifiable,
  placeholder = "Add an item...",
  pillBuilder,
  addItem,
  removeItem
}: {
  items: string[];
  className?: string;
  pillClassName?: string;
  iconClassName?: string;
  modifiable?: boolean;
  placeholder?: string;
  pillBuilder?: (item: string) => JSX.Element;
  addItem?: (item: string) => void;
  removeItem?: (index: number) => void;
}) => {
  const [addingItem, setAddingItem] = useState(false);

  return (
    <div
      className={
        "flex flex-wrap items-stretch justify-start gap-2 " + className
      }
    >
      {items.map((item, index) => (
        <Pill
          key={index}
          className={
            "flex items-center justify-center gap-3 !rounded-xl py-1 pl-4 " +
            pillClassName
          }
        >
          {pillBuilder ? pillBuilder(item) : item}
          <div className="mr-2">
            {modifiable && (
              <MinusCircle
                className={"hover:cursor-pointer " + iconClassName}
                clickEvent={removeItem ? () => removeItem(index) : () => {}}
              />
            )}
          </div>
        </Pill>
      ))}
      {modifiable &&
        (addingItem ? (
          <PillInput
            placeholder={placeholder}
            className={pillClassName}
            iconClassName={iconClassName}
            onBlur={() => setAddingItem(false)}
            onSubmit={addItem ? addItem : () => {}}
          />
        ) : items.length === 0 ? (
          <Pill
            className={
              "flex items-center justify-center gap-3 !rounded-xl py-1 pl-4 " +
              pillClassName
            }
            onClick={() => setAddingItem(true)}
          >
            <span
              className={className
                ?.split(" ")
                .filter(c => c.includes("text"))
                .map(c => c.replace("!", ""))
                .join(" ")}
            >
              {placeholder}
            </span>
            <div className="mr-2">
              <PlusIcon className={"fill-ctb-grey-600 hover:cursor-pointer"} />
            </div>
          </Pill>
        ) : (
          <div className="flex items-center justify-center">
            <PlusIcon
              className={"fill-ctb-grey-600 hover:cursor-pointer"}
              clickEvent={() => setAddingItem(true)}
            />
          </div>
        ))}
    </div>
  );
};

export default PillList;
